/**
 * After POST /message resolves, swap the optimistic row for the server message
 * without dropping URL previews fetched while `_id` was still the temp id, and
 * without leaving a duplicate if `newMessage` already inserted the server `_id`.
 */
export const mergeMessagePreviews = (...sources) => {
  const out = {};
  for (const source of sources) {
    if (!source || typeof source !== 'object') continue;
    Object.assign(out, source);
  }
  return out;
};

const replaceTempMessageInListDraft = (draft, { tempId, real }) => {
  if (!draft?.messages || !real?._id) return;
  const displaced = draft.messages.find(m => m._id === real._id);
  const tempRow = draft.messages.find(m => m._id === tempId);
  const previews = mergeMessagePreviews(displaced?.previews, tempRow?.previews, real.previews);
  draft.messages = draft.messages.filter(m => m._id !== real._id);
  const next = {
    ...real,
    temp: false,
    ...(Object.keys(previews).length ? { previews } : {}),
  };
  const idx = draft.messages.findIndex(m => m._id === tempId);
  if (idx >= 0) {
    draft.messages[idx] = next;
  } else {
    draft.messages.unshift(next);
  }
};

export default replaceTempMessageInListDraft;
